import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class UnderwritingTools extends RestApiModel {
  static getResourceEndpoint() {
    return '/CommercialProducts';
  }

  static getOfflineRaters() {
    return api.get('/GetOfflineRaters ');
  }
}

export default UnderwritingTools;
